import { render, staticRenderFns } from "./WarningReport.vue?vue&type=template&id=a3e240a0&scoped=true&"
import script from "./WarningReport.vue?vue&type=script&lang=js&"
export * from "./WarningReport.vue?vue&type=script&lang=js&"
import style0 from "./WarningReport.vue?vue&type=style&index=0&id=a3e240a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e240a0",
  null
  
)

export default component.exports